import React from 'react';  // eslint-disable-line

const Grabber2 = () => {
    return (
        <svg width="14px" height="6px" viewBox="0 0 14 6" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Admin-CMS" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="custom-content-existing-page-2" transform="translate(-396.000000, -639.000000)">
                    <g id="Icon-/-Drag-Handle-Copy" transform="translate(395.000000, 634.000000)">
                        <polygon id="Shape" points="16 0 16 16 0 16 0 0" />
                        <path d="M14.2499692,6.99999603 C14.4791302,6.99999603 14.6666349,6.81249139 14.6666349,6.58333035 L14.6666349,5.74999901 C14.6666349,5.52083797 14.4791302,5.33333333 14.2499692,5.33333333 L1.74999901,5.33333333 C1.52083797,5.33333333 1.33333333,5.52083797 1.33333333,5.74999901 L1.33333333,6.58333035 C1.33333333,6.81249139 1.52083797,6.99999603 1.74999901,6.99999603 L14.2499692,6.99999603 Z M14.2499692,10.3333214 C14.4791302,10.3333214 14.6666349,10.1458168 14.6666349,9.91665574 L14.6666349,9.08332439 C14.6666349,8.85416336 14.4791302,8.66665872 14.2499692,8.66665872 L1.74999901,8.66665872 C1.52083797,8.66665872 1.33333333,8.85416336 1.33333333,9.08332439 L1.33333333,9.91665574 C1.33333333,10.1458168 1.52083797,10.3333214 1.74999901,10.3333214 L14.2499692,10.3333214 Z" id="grip-lines" fill="#616B7D" />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Grabber2;
